import { ENVIRONMENTS } from "../shared/constants";
const constructGetter = function (value: string) {
  return function () {
    return value;
  };
};

const fetchLTConfig = (env: ENVIRONMENTS) => {
  switch (env) {
    case ENVIRONMENTS.PPE:
      return function () {
        return {
          integrations: {
            TDX: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "qbXUHjP8dFIIZOxv9n4uo0jBdv6G6SXO",
              },
              workflowSettings: {
                PLAY_ASSESSMENTITEM: {
                  appName: "TDX",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "AssessmentItemFactory",
                  url: "https://cdn-dev.acs.pearsondev.tech/tdx-fit-provider/ppe/remoteEntryNoBundle.js",
                  env: "ppe",
                },
              },
            },
            JOURNALS: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "oX5Vm6SEEeSi5QBEAU0081tx20UHE469",
                fitjsUrl: "https://learningapps-ui-ppe.pearson.com/b0/ppe/fit/v1.4.2/fit.min.js",
              },
              workflowSettings: {
                PLAY_WSOL: {
                  appName: "remote",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "FitIntegrator",
                  url: "https://wsng-mf-nft.pearson.com/uiNgMfRemoteEntry.js",
                  env: "ppe",
                },
              },
            },
          },
        };
      };
    case ENVIRONMENTS.PROD:
      return function () {
        return {
          integrations: {
            TDX: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "DwORvasS2sUp6JxhyPluPbnrjsFusXZu",
              },
              workflowSettings: {
                PLAY_ASSESSMENTITEM: {
                  appName: "TDX",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "AssessmentItemFactory",
                  url: "https://cdn.acs.pearsonprd.tech/tdx-fit-provider/prd/remoteEntryNoBundle.js",
                  env: "prd",
                },
              },
            },
            JOURNALS: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "hQ8ZsSZoIjyl8chQLgo7dB7fAlGIFvVG",
                fitjsUrl: "https://learningapps-ui.pearson.com/b0/fit/v1.4.2/fit.min.js",
              },
              workflowSettings: {
                PLAY_WSOL: {
                  appName: "remote",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "FitIntegrator",
                  url: "https://wsng-mf.pearson.com/uiNgMfRemoteEntry.js",
                  env: "prd",
                },
              },
            },
          },
        };
      };
    case ENVIRONMENTS.QA:
      return function () {
        return {
          integrations: {
            TDX: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "qbXUHjP8dFIIZOxv9n4uo0jBdv6G6SXO",
              },
              workflowSettings: {
                PLAY_ASSESSMENTITEM: {
                  appName: "TDX",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "AssessmentItemFactory",
                  url: "https://cdn-dev.acs.pearsondev.tech/tdx-fit-provider/qa/remoteEntryNoBundle.js",
                  env: "qa",
                },
              },
            },
            JOURNALS: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "oX5Vm6SEEeSi5QBEAU0081tx20UHE469",
                fitjsUrl: "https://learningapps-ui-ppe.pearson.com/b0/stg/fit/v1.4.2/fit.min.js",
              },
              workflowSettings: {
                PLAY_WSOL: {
                  appName: "remote",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "FitIntegrator",
                  url: "https://wsng-mf-stg.pearson.com/uiNgMfRemoteEntry.js", // IES login for qaint points to STG env
                  env: "qa",
                },
              },
            },
          },
        };
      };
    case ENVIRONMENTS.STG:
      return function () {
        return {
          integrations: {
            TDX: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "qbXUHjP8dFIIZOxv9n4uo0jBdv6G6SXO",
              },
              workflowSettings: {
                PLAY_ASSESSMENTITEM: {
                  appName: "TDX",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "AssessmentItemFactory",
                  url: "https://cdn-dev.acs.pearsondev.tech/tdx-fit-provider/stg/remoteEntryNoBundle.js",
                  env: "stg",
                },
              },
            },
            JOURNALS: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "oX5Vm6SEEeSi5QBEAU0081tx20UHE469",
                fitjsUrl: "https://learningapps-ui-ppe.pearson.com/b0/stg/fit/v1.4.2/fit.min.js",
              },
              workflowSettings: {
                PLAY_WSOL: {
                  appName: "remote",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "FitIntegrator",
                  url: "https://wsng-mf-stg.pearson.com/uiNgMfRemoteEntry.js",
                  env: "stg",
                },
              },
            },
          },
        };
      };
    case ENVIRONMENTS.DEV:
    default:
      return function () {
        return {
          integrations: {
            TDX: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "qbXUHjP8dFIIZOxv9n4uo0jBdv6G6SXO",
              },
              workflowSettings: {
                PLAY_ASSESSMENTITEM: {
                  appName: "TDX",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "AssessmentItemFactory",
                  url: "https://cdn-dev.acs.pearsondev.tech/tdx-fit-provider/dev/remoteEntryNoBundle.js",
                  env: "dev",
                },
              },
            },
            JOURNALS: {
              commonFitProps: {
                siteId: "6",
                commonIesClientId: "oX5Vm6SEEeSi5QBEAU0081tx20UHE469",
                fitjsUrl: "https://learningapps-ui-ppe.pearson.com/b0/stg/fit/v1.4.2/fit.min.js",
              },
              workflowSettings: {
                PLAY_WSOL: {
                  appName: "remote",
                  launchMode: "WEB_COMPONENT",
                  moduleName: "FitIntegrator",
                  url: "https://wsng-mf-stg.pearson.com/uiNgMfRemoteEntry.js", // IES login for dev points to STG env
                  env: "dev",
                },
              },
            },
          },
        };
      };
  }
};

function getAppConfig(env: ENVIRONMENTS) {
  switch (env) {
    case ENVIRONMENTS.DEV: {
      const learnerEndpoint = "learning-service-dev.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-dev.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-qa.stg-prsn.com"),
        getServiceHostName: constructGetter(graphqlEndpoint),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter(
          "https://login-stg.pearson.com/v1/piapi-int/login/js/v2/session.js",
        ),
        getGTMAuth: constructGetter("RAFSvAg1n6HG6mFYuU0s3w"),
        getGTMPreview: constructGetter("env-3"),
        getAssignmentLaunchURL: constructGetter(
          "https://" + graphqlEndpoint + "/r/assignment/launch",
        ),
        getScoreSyncUrl: constructGetter("https://" + graphqlEndpoint + "/r/assignment/score/sync"),
        getLaunchDarklyClientId: constructGetter("5fa470392368f008d07dd711"),
        getLearnspaceURL: constructGetter("https://dev-learn.bronte.dev-prsn.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getCohortLaunchUrl: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
        getLTConfig: fetchLTConfig(ENVIRONMENTS.DEV),
      };
    }
    case ENVIRONMENTS.QA: {
      const learnerEndpoint = "learning-service-qaint.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-qaint.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-qa.stg-prsn.com"),
        getServiceHostName: constructGetter(graphqlEndpoint),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter(
          "https://login-stg.pearson.com/v1/piapi-int/login/js/v2/session.js",
        ),
        getGTMAuth: constructGetter("RAFSvAg1n6HG6mFYuU0s3w"),
        getGTMPreview: constructGetter("env-3"),
        getAssignmentLaunchURL: constructGetter(
          "https://" + graphqlEndpoint + "/r/assignment/launch",
        ),
        getScoreSyncUrl: constructGetter("https://" + graphqlEndpoint + "/r/assignment/score/sync"),
        getLaunchDarklyClientId: constructGetter("5f48dd1158b578095c12a30f"),
        getLearnspaceURL: constructGetter("https://learn-bronte-qaint.pearson.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getCohortLaunchUrl: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
        getLTConfig: fetchLTConfig(ENVIRONMENTS.QA),
      };
    }
    case ENVIRONMENTS.PPE: {
      const learnerEndpoint = "learning-service-ppe.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-ppe.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-perf.stg-prsn.com"),
        getServiceHostName: constructGetter(graphqlEndpoint),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter(
          "https://login-ppe.pearson.com/v1/piapi-pqa/login/js/v2/session.js",
        ),
        getGTMAuth: constructGetter("Q9O-rqpcZufxlu8kc5oAtQ"),
        getGTMPreview: constructGetter("env-286"),
        getAssignmentLaunchURL: constructGetter(
          "https://" + graphqlEndpoint + "/r/assignment/launch",
        ),
        getScoreSyncUrl: constructGetter("https://" + graphqlEndpoint + "/r/assignment/score/sync"),
        getLaunchDarklyClientId: constructGetter("5fa470802368f008d07dd727"),
        getLearnspaceURL: constructGetter("https://learn-bronte-ppe.pearson.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getCohortLaunchUrl: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
        getLTConfig: fetchLTConfig(ENVIRONMENTS.PPE),
      };
    }
    case ENVIRONMENTS.PROD: {
      const learnerEndpoint = "learning-service.pearson.com";
      const graphqlEndpoint = "graphql-learning-service.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service.prd-prsn.com"),
        getServiceHostName: constructGetter(graphqlEndpoint),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/learn"),
        getPIClientID: constructGetter("hQ8ZsSZoIjyl8chQLgo7dB7fAlGIFvVG"),
        getPILoginURL: constructGetter("https://login.pearson.com/v1/piapi/login/js/v2/session.js"),
        getGTMAuth: constructGetter("BZDe-AMDFM0MIVRf42LnxA"),
        getGTMPreview: constructGetter("env-1"),
        getAssignmentLaunchURL: constructGetter(
          "https://" + graphqlEndpoint + "/r/assignment/launch",
        ),
        getScoreSyncUrl: constructGetter("https://" + graphqlEndpoint + "/r/assignment/score/sync"),
        getLaunchDarklyClientId: constructGetter("5f48dd1158b578095c12a310"),
        getLearnspaceURL: constructGetter("https://learning.pearson.com"),
        getNRAccountId: constructGetter("1322480"),
        getNRAgentId: constructGetter("664913296"),
        getNRLicenseKey: constructGetter("d527718953"),
        getCohortLaunchUrl: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
        getLTConfig: fetchLTConfig(ENVIRONMENTS.PROD),
      };
    }
    case ENVIRONMENTS.STG: {
      const learnerEndpoint = "learning-service-stg.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-stg.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-qa.stg-prsn.com"),
        getServiceHostName: constructGetter(graphqlEndpoint),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter(
          "https://login-stg.pearson.com/v1/piapi-int/login/js/v2/session.js",
        ),
        getGTMAuth: constructGetter("RAFSvAg1n6HG6mFYuU0s3w"),
        getGTMPreview: constructGetter("env-3"),
        getAssignmentLaunchURL: constructGetter(
          "https://" + graphqlEndpoint + "/r/assignment/launch",
        ),
        getScoreSyncUrl: constructGetter("https://" + graphqlEndpoint + "/r/assignment/score/sync"),
        getLaunchDarklyClientId: constructGetter("5fa4706a2368f008d07dd720"),
        getLearnspaceURL: constructGetter("https://learn-bronte-stg.pearson.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getCohortLaunchUrl: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
        getLTConfig: fetchLTConfig(ENVIRONMENTS.STG),
      };
    }
  }
}

export default getAppConfig;
